import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const Legend = styled.legend`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.tertiary};
    margin-bottom: 28px;
`;

export const Row = styled.div`
    display: flex;

    @media (max-width: 500px){
        display: block;
    }
`;

export const Column = styled.div`
    width: 284px;
    margin-right: 70px;

    @media (max-width: 500px){
        width: 100%;
        margin-right: 0px;
    }
`;

export const Description = styled.p`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.grayDark};
    margin-top: -14px;
    margin-bottom: 27px;
`;

export const GroupEditAndDelete = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.grayDark};
    margin-bottom: 12.5px;
    padding-bottom: 9.5px;
`;

export const GroupName = styled.h2`
    font: normal normal normal 14px Circular Std Book;
    color: ${colors.tertiary};
    margin: 0;
`;

